import { PROJECT_LIST_DEFAULT_COLUMNS } from 'src/modules/project-list/constants/columns';
import { projectListClonningReducer } from 'src/modules/project-list/reducers/projectListClonningReducer';
import { projectListColumnsReducer } from 'src/modules/project-list/reducers/projectListColumnsReducer';
import { projectListDataReducer } from 'src/modules/project-list/reducers/projectListDataReducer';
import { projectListDownloadReducer } from 'src/modules/project-list/reducers/projectListDownloadReducer';
import { projectListExportingReducer } from 'src/modules/project-list/reducers/projectListExportingReducer';
import { projectListExportReducer } from 'src/modules/project-list/reducers/projectListExportReducer';
import { projectListImportReducer } from 'src/modules/project-list/reducers/projectListImportReducer';
import { projectListRemovingReducer } from 'src/modules/project-list/reducers/projectListRemovingReducer';
import { projectListUnfollowingReducer } from 'src/modules/project-list/reducers/projectListUnfollowingReducer';
import { ProjectListState } from 'src/modules/project-list/types/ProjectListState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: ProjectListState = {
  data: null,
  columns: PROJECT_LIST_DEFAULT_COLUMNS,
  import: null,
  export: null,
  removing: null,
  downloading: null,
  unfollowing: null,
  clonning: null,
  exporting: null,
};

export const projectListReducer = chainReducers(defaultState, [
  projectListDataReducer,
  projectListColumnsReducer,
  projectListImportReducer,
  projectListExportReducer,
  projectListRemovingReducer,
  projectListDownloadReducer,
  projectListUnfollowingReducer,
  projectListClonningReducer,
  projectListExportingReducer,
]);
